var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 40,
    viewBox: "0 0 240 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M98.7341 0.00366692C99.1494 0.10624 99.5246 0.227135 99.8561 0.362678C100.621 0.685052 101.473 1.20891 102.381 1.9196C103.772 2.99662 105.113 4.63047 106.428 6.87609C106.479 5.5866 106.737 4.60116 106.963 3.97839C107.014 3.80621 107.076 3.65967 107.127 3.54611C107.171 3.43621 107.225 3.32998 107.269 3.24206C107.367 3.03325 107.44 2.90503 107.473 2.85008C108.03 1.87197 108.77 1.11366 109.662 0.611782C110.121 0.340695 110.544 0.142877 110.934 0.00733383H98.7341V0.00366692ZM118.012 32.5194L121.308 40H121.436L137.555 4.85392C138.116 3.67433 138.75 2.69256 139.435 1.94158C140.149 1.14663 140.979 0.560498 141.905 0.190501C142.087 0.120897 142.272 0.0549501 142.469 0H128.47C128.812 0.106237 129.115 0.234453 129.381 0.388313C130.31 0.937814 130.801 1.82435 130.801 2.95998C130.801 3.57909 130.648 4.30809 130.335 5.19828C130.033 6.01154 129.406 7.44757 128.47 9.46241L128.208 10.0485C128.124 10.2354 128.044 10.4222 127.967 10.5761L118.012 32.5194Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.9247 25.8964H9.70797L7.62431 20.3171L5.37672 14.7855L3.15099 20.3464L1.24947 25.8964H0L4.56439 13.7817H6.22185L10.9247 25.8964Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.3539 13.7664H19.5072V14.7518H23.3357C25.9622 14.7518 27.9402 16.8765 27.9402 19.701C27.9402 22.5913 25.8347 24.9432 23.2447 24.9432H19.5035V25.8957L23.2592 25.9103C24.7455 25.9103 26.1152 25.3425 27.1533 24.3058C28.3263 23.1372 28.9711 21.4997 28.9711 19.701C28.9784 16.2647 26.6142 13.7664 23.3539 13.7664Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M45.4508 24.9586V25.8964H37.5497V13.7817H45.4472V14.7232H38.6024V19.1595H44.919V20.0973H38.6024V24.9586H45.4508Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M61.4751 24.9732V25.9111H54.022V13.7817H55.082V24.9732H61.4751Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M71.1143 13.7817H70.0507V25.9001H71.1143V13.7817Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M108.492 25.9037H107.279L105.192 20.3208L102.944 14.7818L100.718 20.3501L98.8132 25.9037H97.5637L102.135 13.7817H103.786L108.492 25.9037Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M88.9785 13.7817V25.9111H87.8565L81.427 16.9176C81.3906 16.8626 81.3506 16.804 81.3068 16.7381L80.1776 14.6756L79.6895 13.7817H80.5164L86.9313 22.7752C87.0151 22.8888 87.0952 23.028 87.179 23.1782L88.2062 25.0831L87.9512 22.9364C87.9294 22.7679 87.9185 22.6104 87.9185 22.4712V13.7817H88.9785Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M80.7495 21.9389V25.91H79.6895V20.6201L80.7495 21.9389Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M202.171 25.9074H200.954L198.863 20.3171L196.612 14.7745L194.382 20.3464L192.477 25.9074H191.224L195.799 13.7708H197.461L202.171 25.9074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M226.944 25.9074H230.784V24.9256H226.959C224.336 24.9256 222.358 22.8045 222.358 19.9838C222.358 17.0971 224.46 14.7489 227.046 14.7489H230.784V13.7964L227.032 13.7817C225.549 13.7817 224.179 14.3496 223.141 15.3863C221.968 16.5549 221.327 18.1887 221.327 19.9874C221.327 23.4127 223.691 25.9074 226.944 25.9074Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M182.649 13.793V25.904H181.527L175.108 16.9251C175.072 16.8702 175.032 16.8116 174.988 16.7456L173.859 14.6868L173.371 13.793H174.194L180.601 22.7718C180.685 22.8854 180.765 23.0246 180.849 23.1748L181.876 25.076L181.621 22.933C181.6 22.7645 181.589 22.607 181.589 22.4678V13.793H182.649Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M174.431 21.9389V25.9063H173.371V20.6201L174.431 21.9389Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M164.802 13.793H163.739V25.904H164.802V13.793Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M240 13.793H238.937V25.904H240V13.793Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M144.228 13.7927H145.441L147.529 19.372L149.773 24.9073L152.002 19.3427L153.903 13.7927H155.153L150.581 25.9074H148.935L144.228 13.7927Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M214.465 25.9103H213.215L209.641 20.6498L208.913 19.5727H211.259C212.563 19.5727 213.623 18.5104 213.623 17.1989C213.623 15.8911 212.563 14.8287 211.259 14.8287H206.837V13.7957H211.259C213.131 13.7957 214.654 15.3233 214.654 17.2026C214.654 19.0818 213.131 20.6095 211.259 20.6095H210.862L214.465 25.9103Z",
    fill: "white"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footerLogo.d5aa315b1e4a8744918311be9047a7c0.svg";
export { ForwardRef as ReactComponent };